import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import * as Sentry from '@sentry/react';

const NotFound = () => {
  useEffect(() => {
    // Log error to Sentry when a user hits 404 page
    Sentry.captureMessage('User accessed a non-existent page', 'warning');
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        <div>
          <h1 className="text-9xl font-extrabold text-blue-600">404</h1>
          <h2 className="mt-6 text-3xl font-bold text-gray-900">Page introuvable</h2>
          <p className="mt-2 text-gray-600">
            Nous n'avons pas pu trouver la page que vous recherchez.
          </p>
        </div>
        <div className="mt-8">
          <Link
            to="/dashboard"
            className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Retourner au tableau de bord
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound; 